import React from 'react';
import styled from 'styled-components';

import CircularProgress from '@material-ui/core/CircularProgress';

const LoadingBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  div {
    width: 24px !important;
    height: 24px !important;
    svg {
      width: 24px;
      height: 24px;
      circle {
        stroke: #7851e7;
      }
    }
  }
`;

const Spinner = () => {
  return (
    <LoadingBox>
      <CircularProgress />
    </LoadingBox>
  );
};

export default Spinner;
